<template>
  <main id="profileBar" :class="{ 'out-of-screen': !isOpened }">
    <header>
      <h1 class="title">Client Profile</h1>
    </header>
    <section>
      <figure class="profile-content">
        <div class="svg-box" :style="{ backgroundColor: client.avatarColor }">
          <inline-svg
            :src="$path.resolve($assets.svg.avatar[client.avatarKey])"
            width="100%"
            height="100%"
            fill="#FFF"
          />
        </div>
        <figcaption class="info hub-grey">
          <p class="identify">Client ID: {{ client.code }}</p>
          <!-- <p>{{client.teamName}}</p> -->
          <p class="registered">Registered: {{ client.fFirstName }}</p>
        </figcaption>
      </figure>
    </section>
    <hr />
    <!-- <section>
      <p class="ref-path">{{client.path}}</p>
    </section> -->
    <section class="client-menu">
      <nav class="client-menu-list">
        <ol>
          <li
            :class="{
              'client-menu-item': true,
              'hub-link': true,
              active: reportRouteName === 'clientProfile',
            }"
            @click="showReport('clientProfile')"
            @keypress.enter="showReport('clientProfile')"
          >
            <a>Client Profile</a>
          </li>
          <li
            :class="{
              'client-menu-item': true,
              'hub-link': true,
              active: reportRouteName === 'clientRecord',
            }"
            @click="showReport('clientRecord')"
            @keypress.enter="showReport('clientRecord')"
          >
            <a>Client Records</a>
          </li>
          <li
            :class="{
              'client-menu-item': true,
              'hub-link': true,
              active: reportRouteName === 'clientOutcome',
            }"
            @click="showReport('clientOutcome')"
            @keypress.enter="showReport('clientOutcome')"
          >
            <a>Close Client File</a>
          </li>
        </ol>
      </nav>
    </section>

    <div class="toggle-btn clickable" @click="isOpened = !isOpened" @keypress.enter="isOpened = !isOpened">
      <p class="circle" />
      <p class="circle" />
      <p class="circle" />
    </div>
  </main>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import $assets from '@/assets';
import useSessionStore from '@/stores/session';
import $path from '@/utils/path';

const $route = useRoute();
const $router = useRouter();
const SessionStore = useSessionStore();
const isOpened = ref(true);

const reportRouteName = computed(() => {
  return $route.name;
});

if (['clientProfile', 'clientOutcome'].includes(reportRouteName.value)) {
  isOpened.value = false;
}

const client = computed(() => {
  const { currentClient } = SessionStore.HUBSettings;

  return currentClient.id
    ? {
        id: currentClient.id,
        code: currentClient.code,
        avatarColor: currentClient.avatar_color_meta_value,
        avatarKey: currentClient.avatar_meta_value,
        fFirstName: currentClient.facilitator_first_name,
      }
    : {};
});

function showReport(routeName) {
  if (routeName === reportRouteName.value) {
    return;
  }
  isOpened.value = false;
  $router.push({ name: routeName });
}
</script>

<style scoped>
#profileBar {
  display: flex;
  flex-flow: column;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  margin: 0;

  box-sizing: border-box;
  width: min(60%, 18em);
  height: 100%;
  border-left: 2px solid #a7a9ac;
  padding-top: 1em;

  background: #fff;
  transition: right 0.3s;
}
#profileBar.out-of-screen {
  right: max(-60%, -18em);
}

.profile-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.svg-box {
  margin: 1em 0;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  padding: 1em;
}

.info {
  text-align: center;
}
.info .identify,
.info .registered {
  margin-top: 1.5em;
}

/* .ref-path {
} */

hr {
  margin-top: 1em;
  width: 90%;
  height: 1px;
  border: 0 none;
  background: #a7a9ac;
}

.client-menu {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 0;
  padding: 0;
  width: 100%;
}
.client-menu-list {
  margin: 0;
  padding: 0;
}
.client-menu-item {
  display: block;
  padding: 1.8em 0;
  background: #a7a9ac;
  text-align: center;
  color: #fff;
}
.client-menu-item.active {
  background: #8ac640;
}

.toggle-btn {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-evenly;

  position: absolute;
  left: calc(-1.2em - 2px);
  top: 0.5em;

  box-sizing: border-box;
  height: 2.8em;
  width: 1.2em;
  border-radius: 0.4em 0 0 0.4em;
  padding: 0.4em 0;
  background: #8ac640;
}
.circle {
  margin: 0;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #fff;
}

/** Landscape mobile */
@media only screen and (orientation: landscape) and (max-height: 600px) {
  h1.title {
    margin: 0;
  }

  .svg-box {
    margin: 1.5em 0 0.5em;
    width: 3em;
    height: 3em;
  }

  .info > p.identify,
  .info > p.registered {
    margin: 0.5em;
  }

  hr {
    display: none;
  }
}
</style>
